
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4599)"}},[_c('path',{attrs:{"d":"M11.796 4.481c-.723-2.757-3.2-4.552-5.879-4.469C3.664-.12 1.384.824 0 2.614a6.06 6.06 0 012.296-1.198A6.104 6.104 0 00.266 7.1a5.329 5.329 0 01.492-2.035v-.001c.029 1.3.47 2.578 1.33 3.618-.979-1.94-.57-4.936 1.07-6.103a1.69 1.69 0 00-.055.04c.297-.15.613-.273.947-.365 2.728-.746 5.528.916 6.26 3.701a5.282 5.282 0 01-.962 4.626c-1.367-.256-1.357-1.59.357-2.9L8.45 6.76c-.05.146-.103.282-.159.41L3.373 3.734c-.476-.272-.778.284-.401.524l5.004 3.493c-.834 1.242-2 .98-2.516-.371-1.374 1.15-.737 3.211.584 4.122 1.204.83 2.999.656 3.788-.797a6.095 6.095 0 001.965-6.225zM6.434.062l.013.002-.013-.002zm.08 1.698a3.593 3.593 0 00-.08-.038l.08.038zm-.123-.058l-.083-.037.083.037zm-.53-.207l-.09-.029.09.03zm-.123-.04zm-3.172-.107zm1.23-.156a5.795 5.795 0 00-.117.004l.117-.004zm-.133.005zm-.552.051zm-.274.044zm-.142.028zM.8 4.2zm-.015.138l.01-.086a5.44 5.44 0 00-.01.086zM3.95 1.19zm1.245.125zm-.551-.088c-.045-.004-.09-.01-.135-.013l.135.013zm-.146-.014l-.119-.01.119.01zm-.147-.011a4.753 4.753 0 00-.107-.006l.107.006zM6.957.152a.463.463 0 01.026.006L6.957.153zm.164.037l.038.01-.038-.01zm.164.042l.042.01-.042-.01zm.17.047l.035.01-.035-.01zm.36.116l.031.012a.755.755 0 00-.032-.012zm.156.058l.052.02-.052-.02zm.156.062l.057.024-.057-.024zm.157.067l.056.025a3.435 3.435 0 00-.056-.025zm.582 10.53l.067-.065-.067.065zm-.007.007l-.066.062.066-.062zm-.077.071zm-.236.204l-.06.048.06-.048zm-.419.306zm.721-.328l-.053.03.053-.03zm-.35.174l-.071.032.07-.032z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4599"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    